import { render, staticRenderFns } from "./housing-information.vue?vue&type=template&id=11f09586&scoped=true&"
import script from "./housing-information.vue?vue&type=script&lang=js&"
export * from "./housing-information.vue?vue&type=script&lang=js&"
import style0 from "./housing-information.vue?vue&type=style&index=0&id=11f09586&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f09586",
  null
  
)

export default component.exports